import { NOT_ACCREDITED_FORBIDDEN_CODE } from '@/api/error-codes';
import { useGetUserProfile } from '@/api/user-dashboard/queries';
import { PagePaths } from '@/routes/page-paths';
import { useSelectedUserConfigSlice } from '@/stores/selectors';

export { NOT_ACCREDITED_FORBIDDEN_CODE };

export const NON_ACCREDITED_TOOLTIP =
  'This section is only available to accredited investors. Based on the information you provided, you do not currently meet the accredited investor criteria required to access this content.';

export const NON_ACCREDITED_GATED_HREFS: string[] = [
  PagePaths.allFunds,
  PagePaths.deals,
  PagePaths.introducer,
];

/**
 * Routes that the MainLayout deep-link intercept replaces with the full-page
 * gate. /all-funds (listing) is intentionally absent — the listing page renders
 * its hero + stats and gates inline below them.
 */
export const NON_ACCREDITED_GATED_PATHS: string[] = [
  PagePaths.allFundsId,
  PagePaths.allFundsFeeder,
  PagePaths.deals,
  PagePaths.dealsOfferView,
  PagePaths.dealsCompanyProfile,
  PagePaths.dealsCreateCompany,
  PagePaths.dealsPostOffer,
  PagePaths.introducer,
  PagePaths.introducerUser,
];

export const useIsNonAccredited = (): boolean => {
  const { user } = useGetUserProfile();
  return !!user?.isNonAccredited;
};

/**
 * The accredited-investor gate applies only to the personal account.
 * Admin and entity sessions retain full access regardless of the user's
 * personal accreditation status.
 */
export const useIsAccreditationGated = (): boolean => {
  const isNonAccredited = useIsNonAccredited();
  const { selectedUserRole } = useSelectedUserConfigSlice();
  return isNonAccredited && selectedUserRole === 'user';
};
